import React from 'react';
import PropTypes from 'prop-types';
import MapComponent from 'components/MapComponent';

import { withScriptjs, withGoogleMap } from 'react-google-maps';

import {
  loadingElement,
  containerElement,
  mapElement,
} from 'constants/gmapsNodes';

class WrappedMapContainer extends React.Component {
  getDefaultOptions = () => {
    const { defaultStyles } = this.props;
    return {
      styles: defaultStyles,
      streetViewControl: false,
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: true,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
    };
  };

  render() {
    const {
      activeId,
      center,
      handleToggleClose,
      handleToggleOpen,
      locations,
      markerIcon,
      zoom,
      settings,
    } = this.props;
    return (
      <MapComponent
        className="mapContainer"
        center={center}
        zoom={zoom}
        locations={locations}
        isMarkerShown
        handleToggleOpen={handleToggleOpen}
        handleToggleClose={handleToggleClose}
        activeId={activeId}
        defaultOptions={this.getDefaultOptions()}
        markerIcon={markerIcon}
        displayMoreInfo={settings.displayMoreInfo}
      />
    );
  }
}

const MapContainer = withScriptjs(withGoogleMap(WrappedMapContainer));

MapContainer.propTypes = {
  activeId: PropTypes.number,
  center: PropTypes.object.isRequired,
  containerElement: PropTypes.node,
  defaultStyles: PropTypes.arrayOf(PropTypes.object),
  googleMapURL: PropTypes.string.isRequired,
  handleToggleClose: PropTypes.func.isRequired,
  handleToggleOpen: PropTypes.func.isRequired,
  locations: PropTypes.arrayOf(PropTypes.object),
  loadingElement: PropTypes.node,
  mapElement: PropTypes.node,
  markerIcon: PropTypes.string,
  settings: PropTypes.object.isRequired,
  zoom: PropTypes.number.isRequired,
};

MapContainer.defaultProps = {
  containerElement: containerElement,
  loadingElement: loadingElement,
  mapElement: mapElement,
};

export default MapContainer;
